module.exports = __webpack_public_path__ + "img/plan_parcel.968afed6.jpg";